import { gql } from '@apollo/client';

export const ADD_COUNTRY = gql`
  mutation CreateCountryMutation(
    $master_list: Boolean
    $countries: [JSON]
    $group_id: String
    $company_id: String
    $user_email: String
    $return_batch: Boolean
  ) {
    createCountries(
      master_list: $master_list
      countries: $countries
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
      return_batch: $return_batch
    )
  }
`;

export const DELETE_COUNTRY = gql`
  mutation DeleteCountryMutation(
    $master_list: Boolean
    $country_id: String
    $country_name: String
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    deleteCountry(
      master_list: $master_list
      country_id: $country_id
      country_name: $country_name
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const UPDATE_COUNTRY = gql`
  mutation UpdateCountryMutatino(
    $master_list: Boolean
    $updated_country: JSON
    $original_country: JSON
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    updateCountry(
      master_list: $master_list
      updated_country: $updated_country
      original_country: $original_country
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;
